import React from 'react';
import DesktopNavItem from './DesktopNavItem';
import { NavItem } from './NavbarData';

interface DesktopNavigationProps {
  navItems: NavItem[];
  activeItem: string;
  hoveredItem: string | null;
  isDropdownVisible: boolean;
  onNavClick: (itemId: string) => void;
  onMouseEnter: (itemId: string) => void;
  onMouseLeave: () => void;
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({
  navItems,
  activeItem,
  hoveredItem,
  isDropdownVisible,
  onNavClick,
  onMouseEnter,
  onMouseLeave
}) => {

  return (
    <div className="hidden md:flex items-center justify-center flex-1">
      <div className="flex items-center justify-center h-full space-x-4 md:gap-7 lg:gap-6  xl:gap-10">
        {navItems.map((item) => (
          <DesktopNavItem
            key={item.id}
            item={item}
            isCountry={(item?.children)?true:false}
            isActive={activeItem === item.id}
            isHovered={hoveredItem === item.id}
            isDropdownVisible={isDropdownVisible}
            onNavClick={onNavClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        ))}
      </div>
    </div>
  );
};

export default DesktopNavigation;